import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';

function ConfirmReauthorization({ open, handleClose, handleConfirm }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm">
      <DialogContent>
        <Typography>{t('message.changeEmailConfirmation')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('generic.cancel')}</Button>
        <Button onClick={handleConfirm}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmReauthorization;